import React from "react"
import { Container, Row, Col } from 'react-bootstrap';
import ReactMarkdown from "react-markdown"
import ScrollAnimation from 'react-animate-on-scroll';
// Style
import './AboutSection.scss';
import GetURL from '@Components/common/site/get-url';
import { useLocation } from "@reach/router";
import { getSrc } from "gatsby-plugin-image"
const AboutSection = (props) => {
  const location = useLocation();
  const thePath  = location.pathname
  return (
    <div className="about-section">
      <Container>
        <Row>
          <Col xs>
            <div className="grid">
              {/* <ScrollAnimation animateIn='fadeIn' animateOnce={true} className="box-1 about-content"> */}
              <div className="box-1 about-content">
                <h1>{props.Title}</h1>
                  <div className="d-block d-md-none mb-3">
                    <img className="bg-img" src={getSrc(props.Left_Image?.url_sharp)} alt={props.Left_Image?.alternativeText} />
                   </div>
                <div className="rich-text-editer-block">
                  <ReactMarkdown source={props.Content} allowDangerousHtml />
                </div>
                {props.CTA_1_Label != null && props.CTA_1_URL != null &&
                  <div className="btn-row">
                    <h2><GetURL isLinkArrow="true" label={props.CTA_1_Label} alias={props.CTA_1_URL.Alias} class={'link-text'} /></h2>
                  </div>
                }
                {thePath == "/" &&
                 <div className="box-1-valuation-cta">
                    <a class="btn btn-primary" href="/property-valuation/">Get free Valuation</a>                               
                </div> }
              </div>
              {/* <ScrollAnimation animateIn='fadeIn' animateOnce={true} className="box-2"> */}
              <div className="box-2">
                <div className = "d-none d-md-block">
                 <img className="bg-img" src={getSrc(props.Left_Image?.url_sharp)} alt={props.Left_Image?.alternativeText} />
                </div>
                <div className="rich-text-editer-block">
                  <ReactMarkdown source={props.Left_Image_Caption} allowDangerousHtml />
                </div>
              </div>
              <div className="box-3">
              <div className="rich-text-editer-block">
                  <ReactMarkdown source={props.Right_Image_Caption} allowDangerousHtml />
                </div>
                <img className="bg-img" src={getSrc(props.Right_Image?.url_sharp)} alt={props.Right_Image?.alternativeText} />
                
              </div>
            </div>
          </Col>
        </Row>
      </Container>

    </div>
  )
}



export default AboutSection